.host {
    width: 100%;
}

.host :global(gmp-place-autocomplete) {
    width: 100%;
    color-scheme: light;
    background-color: var(--mantine-color-white);
    color: var(--mantine-color-text);
    border: 1px solid var(--mantine-color-gray-4);
    border-radius: var(--mantine-radius-default);
}
